/**
 * Serializes the multi-condition trait filter into the `userTraits` JSON query
 * param understood by Insights v1 endpoints (AND across keys, OR within a key).
 * Returns undefined when nothing remains after trimming empty keys/values.
 */
export function serializeUserTraits(userTraits: Record<string, string[]> | undefined): string | undefined {
  if (!userTraits) return undefined;
  const cleaned: Record<string, string[]> = {};
  for (const [key, values] of Object.entries(userTraits)) {
    const filtered = (values ?? []).map(value => value.trim()).filter(Boolean);
    if (key.trim() && filtered.length) {
      cleaned[key] = filtered;
    }
  }
  return Object.keys(cleaned).length ? JSON.stringify(cleaned) : undefined;
}
